import defs from '../_core/defs.js';
import removeListener from './_removelistener.js';
import forEach from '../_helpers/foreach.js';
import matchesDelegation from '../on/_delegatelistener/_matchesdelegation.js';
import { dropOwner, hasOwner } from '../on/_owners.js';
import getProp from '../_helpers/getprop.js';
import assign from '../_helpers/assign.js';
import cancelIfGone from './_cancelifgone.js';
// drops the owner from internal events such as _asterisk:add of given delegated listener;
// returns the delegations nobody keeps any more
function detatchDelegatedLogic(_ref) {
  var delegatedEventName = _ref.delegatedEventName,
    allEvents = _ref.allEvents,
    delegation = _ref.delegation,
    owner = _ref.owner,
    exact = _ref.exact;
  var retain = [];
  var removed = [];
  var events = allEvents[delegatedEventName];
  if (!events) {
    return removed;
  }
  forEach(events, function (event) {
    if (!matchesDelegation(event, delegation, exact) || !hasOwner(event, owner) || !dropOwner(event, owner)) {
      retain.push(event);
    } else {
      removed.push(event.info.delegatedData);
    }
  });
  if (retain.length) {
    allEvents[delegatedEventName] = retain;
  } else {
    delete allEvents[delegatedEventName];
  }
  return removed;
}
// removes delegated event listener from an object by given path
export default function undelegateListener(object, givenPath, name, callback, context, info) {
  var _path, _info$owner;
  if (info === void 0) {
    info = {};
  }
  var def = defs.get(object);
  // if no definition do nothing
  if (!def) {
    return;
  }
  var allEvents = def.events;
  // an empty string is kept: its length is 0, as for an empty array
  var path = typeof givenPath === 'string' && givenPath !== '' ? givenPath.split('.') : givenPath;
  if (!((_path = path) != null && _path.length)) {
    // if no path then remove listener
    removeListener(object, name, callback, context, info);
    return;
  }
  // else do all magic
  var key = path[0];
  // the delegation removed here: the user's (null) or a parent's; a parent's removal names its own listener exactly
  var owner = (_info$owner = info.owner) != null ? _info$owner : null;
  var exact = !!owner;
  // the owner the next objects along the path know this delegation by
  info = assign({}, info, {
    owner: {
      object: object,
      path: path.join('.')
    }
  });
  path = path.slice(1);
  var delegation = {
    pathStr: path.join('.'),
    name: name,
    callback: callback,
    context: context
  };
  var detach = function detach() {
    var seen = new Set();
    var removed = [];
    for (var _len = arguments.length, delegatedEventNames = new Array(_len), _key = 0; _key < _len; _key++) {
      delegatedEventNames[_key] = arguments[_key];
    }
    forEach(delegatedEventNames, function (delegatedEventName) {
      return forEach(detatchDelegatedLogic({
        delegatedEventName: delegatedEventName,
        allEvents: allEvents,
        delegation: delegation,
        owner: owner,
        exact: exact
      }), function (data) {
        if (!seen.has(data)) {
          seen.add(data);
          removed.push(data);
        }
      });
    });
    return removed;
  };
  // the next objects lose the listener only through a delegation nobody keeps
  var undelegateFrom = function undelegateFrom(removed, target) {
    if (target && typeof target === 'object') {
      forEach(removed, function (data) {
        return undelegateListener(target, path, name, data.callback, data.context, info);
      });
    }
  };
  var removed = [];
  if (key === '*') {
    // remove asterisk events
    if (object.isMatreshkaArray) {
      removed = detach('_asterisk:add', '_asterisk:remove');
      // undelegate asterisk events for existing items
      forEach(object, function (item) {
        return undelegateFrom(removed, item);
      });
    } else if (object.isMatreshkaObject) {
      removed = detach('_asterisk:set', '_asterisk:remove');
      object.each(function (item) {
        return undelegateFrom(removed, item);
      });
    }
  } else {
    // remove non-asterisk delegated events
    removed = detach("_change:delegated:" + key);
    undelegateFrom(removed, getProp(object, key));
  }
  // the user's off cancels a pending onDebounce call; a parent's undelegation keeps it: another object may hold it
  if (!owner) {
    forEach(removed, function (data) {
      return cancelIfGone(allEvents, data.callback);
    });
  }
}